import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  flex-direction: row;
  @media (max-width: 260px){
    flex-direction: column;
  }
`;

export const Title = styled.div`
  font-size: 12px;
  color: #000FFF;
  font-weight: bold;
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 12px;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Details = styled.div`
  padding: 0px 10px;
  width: 80px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #FFF;
  font-size: 11px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
  margin-top: 8px;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}

export const Left = styled.div`
  margin-left: 10px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 260px){
    align-items: flex-start;
    margin-bottom: 10px;
  }
`

export const Right = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 260px){
    align-items: flex-end;
  }
`
